import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ComponentConfiguration} from '../../../core/models/config';
import {ShoulderChartService} from './shoulder-chart.service';
import {
    JourneyShoulderTrainRequest,
    LegShoulderTrainRequest, ShoulderTrain
} from '../shared/models/shoulder-chart.model';
import {AccessiblePaletteService} from '../../../core/services/accessible-palette/accessible-palette.service';

@Component({
    selector: 'app-shoulder-chart',
    templateUrl: './shoulder-chart.component.html',
    styleUrls: ['./shoulder-chart.component.scss']
})
export class ShoulderChartComponent implements OnChanges {
    @Input() chartRequest: LegShoulderTrainRequest | JourneyShoulderTrainRequest;
    @Input() trainType: 'leg' | 'journey';
    @Input() width?: number;
    @Input() height?: number;
    @Input() padding?: number;
    @Input() title?: string;

    public chartConfig: ComponentConfiguration;
    public chartData: ShoulderTrain[] = [];
    public defaultChartPopupSettings = {
        popupClass: ['default-chart-tooltip-settings']
    };
    private defaultConfig = {
        id: 'shoulder',
        name: 'Shoulder Chart',
        type: 'chart',
        config: {
            metric: {
                bkdDmd: {
                    name: 'Bkd Dmd',
                    style: {color: '#E6E7E8'}
                },
                fcstDmd: {
                    name: 'Fcst Dmd',
                    style: {color: '#0B3EF9'}
                }
            }
        }
    };

    // Same source hex maps to the same accessible hex as the capacity chart, so the two charts stay consistent
    private accessibleColors = {
        bkdDmd: '#71E2AF',
        fcstDmd: '#101D91'
    };

    // One stable object per series: Kendo re-pushes the chart on every input change
    private accessibleBorders: {[metric: string]: {color: string, width: number}} = {
        bkdDmd: {color: '#05053A', width: 1},
        fcstDmd: {color: '#FFFFFF', width: 1}
    };

    constructor(private chartSvc: ShoulderChartService, private paletteSvc: AccessiblePaletteService) {
        const config = this.chartSvc.getComponentConfig();
        this.chartConfig = config ? config : this.defaultConfig;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.chartRequest.currentValue === null || changes.chartRequest.currentValue === undefined) {
            this.resetChart();
        } else {
            this.getChartData();
        }
    }

    public resetChart(): void {
        this.chartData = null;
    }

    public seriesColor(metric: string): string {
        return this.paletteSvc.isEnabled()
            ? this.accessibleColors[metric]
            : this.chartConfig.config.metric[metric].style.color;
    }

    public seriesBorder(metric: string): {color: string, width: number} {
        return this.paletteSvc.isEnabled() ? this.accessibleBorders[metric] : undefined;
    }

    private getChartData(): void {
        this.chartSvc.getShoulderChartData(this.chartRequest, this.trainType).subscribe(resp => {
            this.chartData = resp;
        }, error => {
            console.error(`Error when getting shoulder chart data: ${error}`);
        });
    }

}
